import { EnumSchema } from '../metadata-schema';

export const Uitstroomtype: EnumSchema = {
	"type": "string",
	"title": "Uitstroomtype",
	"enum": [
		"Intern",
		"Extern",
		"VAVO"
	]
};
